import moment from "moment";
import { useNavigate } from "react-router-dom";
import PLACEHOLDER_IMG from "../../../assets/images/avatar.svg";
import CustomEmpty from "../../../components/ui/CustomEmpty";
import CustomPagination from "../../../components/ui/CustomPagination";
import Loader from "../../../components/ui/Loader";
import {
  useGetNotificationsQuery,
  useNotificationStatusMutation,
} from "../../../features/notification/notificationApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { skipData } from "../../../utils/utils";

export default function Notifications() {
  const navigate = useNavigate();
  const { page, limit, handlePagination } = useTable();
  // const [seenId, setSeenId] = useState<number | undefined>(undefined);
  const { isLoading, isError, error, data } = useGetNotificationsQuery({
    params: { limit, skip: skipData(page, limit) },
  });
  const [
    notificationStatus,
    { isError: isSeenError, error: seenError, isLoading: seenLoading },
  ] = useNotificationStatusMutation();
  useError(isError, error, "Get notification fail");
  useError(isSeenError, seenError, "Notification seen fail");

  return (
    <SidebarLayout title="Notifications">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {data?.data?.notifications?.length ? (
            <>
              {data?.data?.notifications?.map((item, index) => (
                <div
                  className={`col-span-1 md:col-span-4 border border-gray-600 rounded-[5px] p-4 mb-4 border-r border-transparent md:border-extra-light cursor-pointer ${
                    item?.status === "unseen" ? "bg-light/30" : "bg-white"
                  }`}
                  key={index}
                  onClick={() => {
                    if (!seenLoading) {
                      // setSeenId(item?.id);
                      if (item?.status === "unseen") {
                        notificationStatus({
                          ids: [item?.id],
                        });
                      }

                      if (item?.type?.includes("support") && item?.target_id) {
                        navigate(
                          `/admin/support-tickets?targeId=${item?.target_id}`
                        );
                      } else if (
                        item?.type?.includes("leave") &&
                        item?.target_id
                      ) {
                        navigate(
                          `/admin/leave/leave-requests/view/${item?.target_id}`
                        );
                      }
                    }
                  }}
                >
                  <div className="flex items-center gap-4 min-w-72">
                    <div className="w-14 h-14">
                      <img
                        className="w-full h-full rounded-full"
                        src={
                          item?.sender?.member?.profile?.pro_pic ||
                          PLACEHOLDER_IMG
                        }
                        alt="User_Image"
                      />
                    </div>
                    <div className="flex flex-col gap-0.5">
                      <h3 className="text-body text-lg font-medium leading-normal">
                        <span className="me-2"> {item?.title}</span>{" "}
                        {/* <span></span> */}
                      </h3>

                      <p className="text-body-text text-sm font-medium leading-normal">
                        {moment.utc(item?.created_at).local().format("DD MMM")}{" "}
                        {moment.utc(item?.created_at).local().format("hh:mm a")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
              <CustomPagination
                total={data?.data?.total_count}
                limit={limit}
                page={page}
                // hidePagination={hidePagination}
                handlePagination={handlePagination}
              />
            </>
          ) : (
            <div className="bg-white rounded-md border border-light/50">
              <CustomEmpty rootClassName="py-10" imageStyle={{ height: 100 }} />
            </div>
          )}
        </>
      )}
    </SidebarLayout>
  );
}
